import React from 'react';

const SnakeShape2 = ({ className }) => {
  return (
    <svg 
      className={className}
      width="335" 
      height="681" 
      viewBox="0 0 335 681" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.21903 -85.8251C-3.59076 -37.804 0.211556 60.8979 94.439 116.713L291.584 214.89C341.251 241.988 342.782 276.05 312.919 320.532C284.105 363.452 104.801 612.633 198.801 736.329" 
        stroke="#9DBCC5" 
        stroke-width="4.5" 
        stroke-dasharray="6 6"
      />
    </svg>
  );
};

export default SnakeShape2;
